import React from "react";
import MovieList from "../components/MovieList";

const Movies = () => {
    return (
        <div>
            <MovieList />
        </div>
    );
};

export default Movies;
